export default "__VITE_ASSET__fitIpMTu__"